import React from 'react';
import { withAbort, withDone } from '../utility/http';
import usePromise from './usePromise';
import useUpdateEffect from './useUpdateEffect';
import { forever } from '../utility/promise';
const start = (fetch) => {
    const [request, abort] = withAbort(fetch);
    return { promise: withDone(request)(), abort };
};
export const useFetch = (fetch, dependencies = []) => {
    const [state, setState] = React.useState({ 'promise': forever(), 'abort': () => { } });
    React.useEffect(() => {
        const next = start(fetch);
        setState(next);
        return next.abort;
    }, []);
    const reload = React.useCallback(() => {
        const next = start(fetch);
        setState((current) => {
            current.abort();
            return next;
        });
        return next.promise;
    }, [fetch]);
    useUpdateEffect(() => {
        reload();
    }, dependencies);
    return [state.promise, reload];
};
export const useFetchPromise = (fetch, dependencies = []) => {
    const [xP, reloadX] = useFetch(fetch, dependencies);
    return [usePromise(xP), reloadX];
};
